import React, {
    useState,
    useEffect,
} from "react";
import { AddDialog } from "../../Components/AddDialog.jsx";
import { Box, Button, Stack, Typography } from "@mui/material";
import { InputSelectMonth } from "../../Components/Inputs/Select.jsx";
import { InputMoney } from "../../Components/Inputs/Input_Money.jsx";
import { AccountUrl_get, empty_uuid, ftchPlus, getOptions, putOptions } from "../../App/Account_urls.jsx";
import { InputNumber } from "../../Components/Inputs/Input_Number.jsx";
import { errorClear, errorSet, errorSetPlus } from "../../Components/Inputs/Input_Fns.jsx";
import { set } from "lodash";
import { CurrentYear } from "./AddInvestAccount.jsx";
import { Arrayify } from "../../Functions/utils.jsx";





const curMonth = new Date().toLocaleString('en-CA', { month: 'short' })

const defAll = {
    RunScenario: false,
    Year: new Date().getFullYear(),
    Month: curMonth,
}



const QuickUpdateC = ({ open, name, form, primary, onError, onChange }) => {
    const [errors, setErrors] = useState({})
    const onChange_any = (n, v) => {
        console.log(n)
        console.log(v)

        let nf = set(form, n, v)
        console.log(nf)
        onChange(nf);
        validation(nf, errors)
        return nf
    };
    const onChange_t = (e) => {
        onChange_any(e.target.name, e.target.value);

    };
    const onChange_list = (e) => {
        let nf = onChange_any(e.target.name, e.target.value);

    };

    const onChange_date = (e) => {
        if (!e.isValid()) {
            errorSetPlus(onError, errors, setErrors, "Birthdate", null, "Invalid Date")
        } else {
            errorSetPlus(onError, errors, setErrors, "Birthdate", null, "")

            let d = e.$y + "-" + (Number(e.$M) + 1).toString() + "-" + e.$D;
            let nf = { ...form, Birthdate: d };

            console.log(nf);
            onChange(nf);
        }
    };

    const validation = (f, e) => {
        let ne = structuredClone(e)

        // let err = (f.Province === "") ? "Please select a province" : ""
        // ne = set(ne, "Province", err)
        // setErrors(ne)
        // onError(errorJsonHasErrors(ne) ? "Errors" : "")
    }
    useEffect(() => {
        validation(form, errors)
    }, [open])

    const myError = (obj, i, err) => {
        errorSetPlus(onError, errors, setErrors, obj, i, err)
    }

    return (
        <>
            {(Arrayify(form).length > 0) && (
                <Box sx={{ m: 2, p: 2, border: "1px solid grey" }}>

                    <Typography id="who" variant="h6" gutterBottom>
                        {name}
                    </Typography>

                    {Arrayify(form).map((cat, cati) => (
                        <React.Fragment key={"rf" + cati}>
                            <Typography variant="body1" gutterBottom>
                                {cat.Category}
                            </Typography>
                            {Arrayify(cat.Types).map((typ, typi) => (
                                <React.Fragment key={"rf" + cati + ":" + typi}>
                                    <Typography sx={{ ml: 5 }} variant="body2" gutterBottom>
                                        {typ.Type}
                                    </Typography>
                                    <Stack sx={{ ml: 10 }} spacing={4}>
                                        {Arrayify(typ.Accounts).map((acc, acci) => (
                                            <Stack direction="row" spacing={2} key={"box" + cati + ":" + typi + ":" + acci} sx={{ ml: 0 }}>
                                                <InputMoney
                                                    xlabel={acc.Name}
                                                    money={acc.Value}
                                                    name={cati + ".Types." + [typi] + ".Accounts." + acci + ".Value"}
                                                    onChange={onChange_t}
                                                    width={200}
                                                    tooltip={"Enter " + acc.Name + "balance"}
                                                    onError={(e) => myError(acc.Name, null, e)}
                                                />
                                                {acc.HasCostBasis && (
                                                    <InputMoney
                                                        xlabel="Cost Basis"
                                                        money={acc.CostBasis}
                                                        name={cati + ".Types." + [typi] + ".Accounts." + acci + ".CostBasis"}
                                                        onChange={onChange_t}
                                                        width={200}
                                                        tooltip={"Enter " + acc.Name + "balance"}
                                                        onError={(e) => myError(acc.Name, null, e)}
                                                    />
                                                )}
                                            </Stack>
                                        ))}
                                    </Stack>
                                </React.Fragment>
                            ))}
                        </React.Fragment>
                    ))}
                </Box>
            )}
        </>
    )
}







export const QuickUpdate = ({ open, onClose, clientJson }) => {
    const [errors, setErrors] = useState({})
    const [errmsg, setErrmsg] = useState("")
    const [deleted, setDeleted] = useState(false)
    const [avail, setAvail] = useState([])
    const [form, setForm] = useState({ ...defAll })

    const getInputData = () => {
        let qyear = ""
        if (form.Year !== 0) {
            qyear = "year=" + form.Year
        }
        let url = AccountUrl_get(clientJson, "quickupdate", "", empty_uuid, false, "", qyear);
        ftchPlus(url, getOptions)
            .then((json) => {
                if (json) {
                    //data.current = json;
                    if (!json.HasValues) {
                        json.Month = curMonth
                    }
                    setForm(json);
                    setAvail(json.Avail)
                    //Update(client_)

                    //console.log(data.current);
                }
            })
            .catch((error) => {
                console.log(error.message);
                setErrmsg(error.message)
            });

    };

    const putRequest = async (runScenario) => {
        let url = AccountUrl_get(clientJson, "quickupdate", "", empty_uuid, false, "");
        var req = putOptions;
        form.RunScenario = runScenario
        req.body = JSON.stringify(form);
        ftchPlus(url, req)
            .then((json) => {
                console.log("update completed");
                onClose(json);
            })
            .catch((error) => {
                console.log(error.message);
                setErrmsg(error.message)
            });
    };

    const myClose = () => {
        onClose({})
    }

    const onSubmit = () => {
        putRequest(false)
    }

    const onChange_any = (n, v) => {
        let nf = {
            ...form,
            [n]: v,
        };
        setForm(nf);
    };

    const onChange_t = (e) => {
        onChange_any(e.target.name, e.target.value);
    };

    const onError = () => {

    }
    const onChangeClient = (who, v) => {
        onChange_any(who, v)
    }

    const validation = (f) => {
    }

    const myErrorSet = (obj, i, err) => {
        let ne = errorSet(errors, setErrors, obj, i, err)
    }

    useEffect(() => {
        errorClear(errors)
        setErrmsg("")
        setForm({ ...defAll })
    }, [open])

    const onExtraButton = () => {
        putRequest(true)
    }




    return (
        <AddDialog
            clientJson={null}
            c_callback={null}
            onClose={myClose}
            open={open}
            clients={[]}
            client={""}
            label="Quick Update"
            accountType="QuickUpdate"
            onClientChange={() => { }}
            onSubmit={onSubmit}
            submitTooltip="Save the client, without running a scenario.  This allows you to make other changes before running the scenario."
            errors={errors}
            errmsg={errmsg}
            deleted={deleted}
        // extraButton="Run Scenario"
        // onExtraButton={onExtraButton}
        // extraButtonTooltip="Run the scenario directly from here"
        >

            <Stack sx={{ mx: 20, mb: 10 }} spacing={2}>
                <Typography sx={{ pb: 4 }} variant="body1" gutterBottom>
                    The Account Quick Update allows you to enter a single value for the year for each existing investment, property, liability account.<br />
                    Fetching accounts will gather the accounts you may update and any current values for the given year.<br />
                    A zero value will not change that accounts value.<br />
                </Typography>
                <Box>
                    <Stack spacing={2}>
                        <Stack sx={{ my: 8 }} direction="row" spacing={2}>
                            <InputNumber
                                label="Year"
                                name="Year"
                                number={form.Year}
                                onChange={onChange_t}
                                width={200}
                                min={2010}
                                max={new Date().getFullYear()}

                            //onError={(e) => { setDoValidation(doValidation + 1); myError("year", null, e) }}
                            />
                            <InputSelectMonth
                                label="Month"
                                name="Month"
                                value={form.Month}
                                onChange={onChange_t}
                                errors={errors}
                                disabled={Number(form.Year) !== CurrentYear()}
                                tooltip="If this is the current year this is the value in this month.  Return will be prorated from this value for the rest of the year, when this is the current year."
                            //onError={(e) => myError("month", null, e)}
                            />
                            <Button
                                onClick={getInputData}
                                variant={Arrayify(form.ClientAccounts).length === 0 ? "contained" : "outlined"}
                            >
                                Fetch Accounts
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
                <Box>
                    <Stack direction="row" spacing={20}>
                        <QuickUpdateC
                            open={open}
                            name={clientJson.name}
                            form={form.ClientAccounts}
                            onChange={(c) => (onChangeClient("Client", c))}
                            errors={errors}
                            onError={(e) => myErrorSet("client", null, e)}
                        />
                        {(clientJson.spouseName !== "") &&
                            <QuickUpdateC
                                open={open}
                                name={clientJson.spouseName}
                                form={form.SpouseAccounts}
                                onChange={(c) => (onChangeClient("Client", c))}
                                errors={errors}
                                onError={(e) => myErrorSet("client", null, e)}
                            />
                        }
                    </Stack>
                </Box>
            </Stack>
        </AddDialog>

    )

}